import React from 'react'
import { User } from '../interface/User';
import moment from 'moment';
const Modal = ({ displayProfile, setDisplayProfile }: { displayProfile: User | undefined; setDisplayProfile: React.MouseEventHandler<HTMLButtonElement> }) => {
    if (!displayProfile) return <></>
    const { cell, dob, email, gender, location, name, nat, phone, picture } = displayProfile
    return (
        <div>
            <div style={{ background: 'rgba(0,0,0,.8)', position: 'fixed', left: 0, top: 0, width: '100vw', height: '100vh' }}></div>
            <div className='profile-details d-flex'>
                <div className="box">
                    <div id="overlay">
                        <div className="image" style={{ background: `url(${picture.large}) center center no-repeat`, backgroundSize: 'cover' }}>
                            <div className="trick">

                            </div>
                        </div>
                        <ul className="text">{phone}</ul>
                        <div className="text1">{name.first + ' ' + name.last}</div>’
                        <div className="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
                            <div className="panel panel-default">
                                <div className="panel-heading " role="tab" id="headingOne">
                                    <h4 className="panel-title ">
                                        <a role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-controls="collapseOne">
                                            <div style={{ textTransform: 'uppercase' }} className="title  btn btn-danger btn-outline btn-lg">Basic information</div>                                        </a>
                                    </h4>
                                </div>
                                <div id="collapseOne" className="panel-collapse collapse in" role="tabpanel" aria-labelledby="headingOne">
                                    <div className="panel-body">
                                        <ul style={{ paddingLeft: 0 }}>
                                            {[{ title: 'Cell', value: cell, icon: 'mobile' }, { title: 'Birthday', value: moment(dob.date).format("Do MMM, YYYY"), icon: 'child' }, { title: 'Gender', value: gender, icon: 'anchor' }, { title: 'Email', value: email, icon: 'envelope' }].map(({ title, value, icon }) => <li style={{ whiteSpace: 'nowrap', display: 'flex', justifyContent: 'space-between' }}><span style={{ display: 'block', flexBasis:'10%', textAlign:'center' }}><i
                                                className={`fa fa-${icon}`} aria-hidden="true"></i></span><span style={{ fontWeight: '600', display:'block', flex: 3 }}>{`${title}: ${value}`}</span></li>)}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="panel panel-default">
                                <div className="panel-heading" role="tab" id="headingTwo">
                                    <h4 className="panel-title">
                                        <a className="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                            <div className="title btn btn-danger btn-outline btn-lg">ORIGIN</div>
                                        </a>
                                    </h4>
                                </div>
                                <div id="collapseTwo" className="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwo">
                                <div className="panel-body">
                                        <ul style={{ paddingLeft: 0 }}>
                                            {[{ title: 'Timezone', value: location.timezone.description, icon: 'clock-o' }, { title: 'Nationality', value: nat, icon: 'flag' }].map(({ title, value, icon }) => <li key={icon} style={{ whiteSpace: 'nowrap', display: 'flex', justifyContent: 'space-between' }}><span style={{ display: 'block', flexBasis:'10%', textAlign:'center' }}><i
                                                className={`fa fa-${icon}`} aria-hidden="true"></i></span><span style={{ fontWeight: '600', display:'block', flex: 3 }}><>{`${title}: ${value}`}</></span></li>)}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="panel panel-default">
                                <div className="panel-heading" role="tab" id="headingThree">
                                    <h4 className="panel-title">
                                        <a className="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                            <div className="title btn btn-danger btn-outline btn-lg">CONTACT</div>
                                        </a>
                                    </h4>
                                </div>
                                <div id="collapseThree" className="panel-collapse collapse" role="tabpanel" aria-labelledby="headingThree">
                                    <div className="panel-body">
                                        <form id="form" className="topBefore">
                                            <input id="name" type="text" placeholder="NAME" />
                                            <input id="email" type="text" placeholder="E-MAIL" />
                                            <textarea id="message" placeholder="MESSAGE"></textarea>
                                            <input id="submit" type="submit" value="Submit Now!" />
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <button className='position-abosule align-self-start rounded rounded-circle' onClick={setDisplayProfile}><i className="fa fa-times-circle fa-3x"
                    aria-hidden="true"></i></button>
            </div>
        </div>

    )
}

export default Modal